import { FileText } from "lucide-react";
import { useSecureFileUrl } from "@tellescope/tanstack-query";
import { FileImagePreview } from "./FileImagePreview";

interface FileUploadedItemPreviewProps {
  name: string;
  secureName: string;
  type?: string;
}

export const FileUploadedItemPreview = ({ name, secureName, type }: FileUploadedItemPreviewProps) => {
  const url = useSecureFileUrl(secureName);
  const isImage = type?.startsWith("image/");

  if (!isImage) {
    return <FileText className="h-4 w-4 text-muted-foreground flex-shrink-0" />;
  }

  if (!url) {
    return <div className="h-10 w-10 rounded bg-muted animate-pulse flex-shrink-0" />;
  }

  return <FileImagePreview src={url} alt={name} />;
};
